import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import axios from 'axios'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { MDBDataTable } from 'mdbreact'
import { Col, Row } from 'react-bootstrap'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { toast } from 'react-toastify'
import {
  RoomApprovalApi,
  RoomApprovalPendingApi,
  RoomApprovalViewgApi,
} from '../../ApiFile'
import { CircularProgress } from '@mui/material'
import MobileNavbarAdmin from './MobileNavbarAdmin'

export default function RoomApproval() {
  const [rows, setRows] = useState([])
  const [open, setOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState([])
  const [selectedRowId, setSelectedRowId] = useState(null)
  const [alertOpen, setAlertOpen] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusRow, setStatusRow] = useState(null)
  const [rowToDelete, setRowToDelete] = useState(null)
  const [checkBoxChecked, setCheckBoxChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleCheckBoxChange = () => {
    setCheckBoxChecked(!checkBoxChecked)
  }

  function capitalizeWords(str) {
    return str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
  }

  const fetchData = () => {
    axios
      .get(RoomApprovalPendingApi)
      .then((response) => {
        const mappedRows = response.data.map((row, index) => ({
          ...row,
          Name: row.name,
        }))
        setRows(mappedRows)
      })
      .catch((error) => {
        // console.error(error);
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleViewClick = (row) => {
    setSelectedRow(row || {})
    setOpen(true)

    axios
      .get(`${RoomApprovalViewgApi}/${row.reg_id}`)
      .then((response) => {
        setSelectedRow(data.response.data)
      })
      .catch((error) => {
        // console.error(error);
      })
  }

  const handleApproval = () => {
    setLoading(true)
    if (!checkBoxChecked) {
      alert('Please select the checkbox before proceeding.')
      return
    }

    const approvalData = {
      allocate_id: statusRow.allocate_id,
      member_id: statusRow.member_id,
      flag: 2, // Flag for approval
    }

    axios
      .put(RoomApprovalApi, approvalData)
      .then((res) => {
        if (res.data === 'APPROVAL') {
          toast.success('Approved Successfully..!')
          setStatusModalOpen(false)
          fetchData() // Refresh data after approval
          setLoading(false)
        }
      })
      .catch((err) => {
        // console.error("Failed to save data:", err);
        toast.error('Failed...', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
        setLoading(false)
      })
  }

  const handleDelete = (id) => {
    setLoading(true)
    if (!checkBoxChecked) {
      alert('Please select the checkbox before proceeding.')
      return
    }
    const rejectionData = {
      allocate_id: statusRow.allocate_id,
      member_id: statusRow.member_id,
      flag: 3, // Flag for approval
    }

    axios
      .put(RoomApprovalApi, rejectionData)
      .then((res) => {
        setDialogOpen(false)
        if (res.data === 'REJECT') {
          toast.success('Rejected Successfully..!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          fetchData()
          setStatusModalOpen(false)
          setLoading(false)
        }
      })
      .catch((err) => {
        // console.error("Failed to save data:", err);
        toast.error('Failed...', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
        setLoading(false)
      })
  }

  const handleDeleteConfirmation = (id) => {
    setRowToDelete(id)
    setDialogOpen(true)
  }

  const handleStatusModalOpen = (row) => {
    setStatusRow(row)
    handleViewClick(row)
    setStatusModalOpen(true)
  }

  const data = {
    columns: [
      { label: 'Reg ID', field: 'reg_id' },
      { label: 'Name', field: 'Name', width: 150 },
      {
        label: 'View',
        field: 'View',
        render: (row) => (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleViewClick(row)}
            style={{ fontSize: '12px' }}
          >
            <span className="me-1">View</span> <i class="fa-regular fa-eye"></i>
          </Button>
        ),
      },
      {
        label: 'Status',
        field: 'Status',
        render: (row) => {
          if (row.room_approval === '1') {
            return (
              <Button
                variant="contained"
                className="w-50"
                style={{
                  backgroundColor: 'orange',
                  color: 'white',
                  fontSize: '12px',
                }}
                onClick={() => handleStatusModalOpen(row)}
              >
                <span className="me-1">Pending</span>{' '}
                <i class="fas fa-spinner"></i>
              </Button>
            )
          } else if (row.room_approval === '2') {
            return (
              <Button
                variant="contained"
                className="w-50"
                style={{
                  backgroundColor: 'green',
                  color: 'white',
                  fontSize: '12px',
                }}
                disabled
              >
                <span className="me-1">Approved</span>{' '}
                <i class="fas fa-check"></i>
              </Button>
            )
          } else {
            return (
              <Button
                variant="contained"
                className="w-50"
                style={{
                  backgroundColor: 'red',
                  color: 'white',
                  fontSize: '12px',
                }}
                disabled
              >
                <span className="me-1">Rejected</span>{' '}
                <i class="fas fa-times"></i>
              </Button>
            )
          }
        },
      },
    ],
    rows: rows.map((row) => ({
      ...row,
      View: (
        <Button
          variant="contained"
          className="w-50"
          color="primary"
          onClick={() => handleViewClick(row)}
          style={{ fontSize: '12px' }}
        >
          <span className="me-1">View</span> <i class="fa-regular fa-eye"></i>
        </Button>
      ),
      Status:
        row.room_approval === '1' ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleStatusModalOpen(row)}
            className="w-50"
            style={{
              backgroundColor: 'orange',
              color: 'white',
              fontSize: '12px',
            }}
          >
            <span className="me-1">Pending</span> <i class="fas fa-spinner"></i>
          </Button>
        ) : row.room_approval === '2' ? (
          <Button
            variant="contained"
            className="w-50"
            style={{
              backgroundColor: 'green',
              color: 'white',
              fontSize: '12px',
            }}
            disabled
          >
            <span className="me-1">Approved</span> <i class="fas fa-check"></i>
          </Button>
        ) : (
          <Button
            variant="contained"
            className="w-50"
            style={{ backgroundColor: 'red', color: 'white', fontSize: '12px' }}
            disabled
          >
            <span className="me-1">Rejected</span> <i class="fas fa-times"></i>
          </Button>
        ),
    })),
  }

  return (
    <>
      {/* <Sidebar /> */}
     <div className="d-none d-md-block">
                          <Sidebar />
                        </div>
                  
                        <section className="home-section pb-5">
                           <NavLogo />
                  
                        <div className="d-block d-md-none">
                          <MobileNavbarAdmin />
                        </div>
        <div className="block-header">
          <h2
            className="text-center mt-md-4 mt-2 m-0 p-0"
            style={{ color: 'maroon' }}
          >
            Room Approve
          </h2>
        </div>

        <Row
          className="m-0 p-0 px-md-3 py-1 pb-5 mt-4 w-100"
          style={{ display: 'flex' }}
        >
          <Col
            className="m-0 p-0 px-3 py-3 rounded"
            style={{ background: 'white' }}
          >
            <div style={{ overflowY: 'auto' }}>
              <div style={{ overflowX: 'auto' }}>
                <MDBDataTable
                  striped
                  className="custom-datatable text-center"
                  bordered
                  hover
                  small
                  data={data}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '700px',
              maxHeight: '90vh',
              overflow: 'scroll',
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                overflowY: 'auto',
                p: 4,
                flex: 1,
              }}
            >
              <Typography
                id="modal-modal-description"
                style={{ lineHeight: '30px' }}
              >
                <div className="block-header">
                  <h2
                    className="mb-3"
                    style={{
                      color: 'maroon',
                      borderBottom: '2px solid maroon',
                    }}
                  >
                    Room Approve
                  </h2>
                </div>
                <Row>
                  <Col>
                    {' '}
                    <b>Student Name</b>:
                  </Col>
                  <Col> {selectedRow.name} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Block Name</b>:
                  </Col>
                  <Col> {selectedRow.block_id} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Room Name</b>:
                  </Col>
                  <Col> {selectedRow.room_id} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Bed Name</b>:
                  </Col>
                  <Col> {selectedRow.bed_id} </Col>
                </Row>
              </Typography>
            </Box>
            <Box
              sx={{
                p: 2,
                borderTop: '1px solid #ccc',
                textAlign: 'right',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>

        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogTitle>{'Reject Student'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to reject the student?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => handleDelete(rowToDelete)}
              color="primary"
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Modal
          open={statusModalOpen}
          onClose={() => setStatusModalOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '700px',
              maxHeight: '90vh',
              overflow: 'scroll',
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                overflowY: 'auto',
                p: 4,
                flex: 1,
              }}
            >
              <Typography
                id="modal-modal-description"
                style={{ lineHeight: '30px' }}
              >
                <div className="block-header">
                  <h2
                    className="mb-3"
                    style={{
                      color: 'maroon',
                      borderBottom: '2px solid maroon',
                    }}
                  >
                    Room Approve
                  </h2>
                </div>
                <Row>
                  <Col>
                    {' '}
                    <b>Student Name</b>:
                  </Col>
                  <Col> {selectedRow.name} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Block Name</b>:
                  </Col>
                  <Col> {selectedRow.block_id} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Room Name</b>:
                  </Col>
                  <Col> {selectedRow.room_id} </Col>
                </Row>
                <Row>
                  <Col>
                    {' '}
                    <b>Bed Name</b>:
                  </Col>
                  <Col> {selectedRow.bed_id} </Col>
                </Row>

                <Box>
                  <Checkbox
                    className="ps-0 m-0"
                    style={{ position: 'relative' }}
                    checked={checkBoxChecked}
                    onChange={handleCheckBoxChange}
                  />{' '}
                  <b>Check And Proceed..</b>
                  <Row>
                    <Col>
                      <Button
                        variant="contained"
                        color="primary"
                        className="w-100"
                        onClick={() => handleApproval(statusRow?.reg_id)}
                        style={{ marginRight: '10px' }}
                        disabled={loading} // Disable button while loading
                      >
                        {loading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          'Approve'
                        )}
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="contained"
                        className="w-100"
                        color="secondary"
                        onClick={() =>
                          handleDeleteConfirmation(statusRow?.reg_id)
                        }
                      >
                        Reject
                      </Button>
                    </Col>
                  </Row>
                </Box>
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                borderTop: '1px solid #ccc',
                textAlign: 'right',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => setStatusModalOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </section>
    </>
  )
}
